import { render, staticRenderFns } from "./settleLawsuit.vue?vue&type=template&id=70481b32&scoped=true"
import script from "./settleLawsuit.vue?vue&type=script&lang=js"
export * from "./settleLawsuit.vue?vue&type=script&lang=js"
import style0 from "./settleLawsuit.vue?vue&type=style&index=0&id=70481b32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70481b32",
  null
  
)

export default component.exports